import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';

import { Metro } from '../Metro';
import Icon from '../../assets/icon.svg';
import styles from './styles.pcss';

const cx = classNames.bind(styles);

export function MapSimpleBaloon({ point, isMobile, className, children }) {
  const onClickMore = (e) => {
    e.target.parentNode.innerHTML = point.dop_info;
  };
  return (
    <div
      id="ya_baloon_wrapper"
      tabIndex={0}
      role="button"
      className={cx('ya-map__baloon', className, isMobile && 'mobile')}
    >
      <div className={cx('ya_baloon_inner', isMobile && 'mobile')}>
        <div className={cx('ya-map__title', isMobile && 'mobile')}>
          {point.name}{' '}
          {point.badge ?
            <span className={cx('ya-map__badge')}>{point.badge}</span>
          : null}
        </div>
        {point.price > 0 ?
          <div className={cx('ya-map__subtitle', isMobile && 'mobile')}>
            Cтоимость самовывоза {point.price} ₽
          </div>
        : null}
        {point.onlyCard ?
          <div className={cx('ya-map__card')}>
            <Icon /> <span className={cx('ya-map__text')}>{point.onlyCardTitle}</span>
          </div>
        : <div className={cx('ya-map__card')}>{point.priceSubTitle}</div>}
        <Metro {...point} />
        <div className={cx('ya-map__address', isMobile && 'mobile')}>{point.address}</div>
        <div className={cx('ya-map__time', isMobile && 'mobile')}>{point.opening}</div>
        {point.dop_info ?
          <div className={cx('ya-map__dop', isMobile && 'mobile')}>
            <b>Дополнительная информация:</b>
            {point.dop_info.length < 35 ?
              <div>{point.dop_info}</div>
            : <div>
                {point.dop_info.slice(0, 35)}
                ...
                <span
                  className={cx('ya-map__more')}
                  role="button"
                  tabIndex="0"
                  onClick={onClickMore}
                >
                  Подробнее
                </span>
              </div>
            }
          </div>
        : null}
      </div>
      {children}
    </div>
  );
}

MapSimpleBaloon.defaultProps = {
  point: {},
};

MapSimpleBaloon.propTypes = {
  point: PropTypes.shape({
    badge: PropTypes.string,
    name: PropTypes.string,
    address: PropTypes.string,
    opening: PropTypes.string,
    price: PropTypes.number,
    priceSubTitle: PropTypes.string,
    subway: PropTypes.shape({
      name: PropTypes.string,
      color: PropTypes.string,
    }),
    isMovement: PropTypes.bool,
    movement_date: PropTypes.string,
    movement_time: PropTypes.string,
    onlyCard: PropTypes.bool,
    onlyCardTitle: PropTypes.string,
    dop_info: PropTypes.string,
  }),
  isMobile: PropTypes.bool,
  className: PropTypes.string,
  children: PropTypes.any,
};
